module.exports = __webpack_public_path__ + "img/delivery.c84bdcc2.svg";